import styles from './Textarea.module.scss';
import React, { forwardRef } from 'react';
import { FormLabel, FormInput, FormError } from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Textarea = forwardRef(
  (
    {
      className = null,
      inputClassName = null,
      label,
      name,
      placeholder = null,
      required = false,
      store,
    },
    ref,
  ) => (
    <div className={classNames(styles.container, className)}>
      <FormLabel
        className={styles.label}
        name={store.names[name]}
        store={store}
      >
        {label}
      </FormLabel>
      <FormInput
        aria-required={required}
        className={classNames(styles.input, inputClassName)}
        name={store.names[name]}
        placeholder={placeholder}
        ref={ref}
        render={<textarea />}
        required={required}
        store={store}
      />
      <FormError
        aria-atomic="true"
        className={styles.message}
        name={store.names[name]}
        store={store}
      />
    </div>
  ),
);

Textarea.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,

  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  /** `useFormStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
};

Textarea.displayName = 'Textarea';

export default Textarea;
